import { Helmet } from 'react-helmet-async'

export default function HuongDanDatHang() {
    return (
        <>
            <Helmet>
                <title>Hướng dẫn đặt hàng - Dược Tâm Hạnh</title>
                <meta name="description" content="Hướng dẫn đặt hàng và thanh toán tại Dược Tâm Hạnh. Quy trình đơn giản, nhanh chóng." />
            </Helmet>
            <div className="container mx-auto px-0 space-y-4">
                <div className="w-full mx-auto py-8">
                    <div className="bg-gray-50 rounded-xl p-6">
                        <h1 className="styles_title__Gtg9D">Hướng dẫn đặt hàng & thanh toán</h1>
                        <ol className="space-y-3 text-sm text-gray-600">
                            <li><b>Bước 1:</b> Chọn sản phẩm bạn muốn mua.</li>
                            <li><b>Bước 2:</b> Thêm sản phẩm vào giỏ hàng.</li>
                            <li><b>Bước 3:</b> Kiểm tra giỏ hàng và tiến hành thanh toán.</li>
                            <li><b>Bước 4:</b> Nhập thông tin nhận hàng.</li>
                            <li><b>Bước 5:</b> Xác nhận đơn và chờ giao hàng.</li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    )
}
